import { Controller } from "@hotwired/stimulus"
import { attachHereAutocomplete } from "../helpers/here_places"

export default class extends Controller {
  static targets = ["field", "postal", "city", "country"]

  connect() {
    this.teardown = attachHereAutocomplete(this.fieldTarget, {
      onSelect: (fields) => this.setAddressFields(fields),
    })
  }

  disconnect() {
    if (this.teardown) this.teardown()
  }

  // Enter while the suggestion list is open means "take the highlighted address", so it
  // must not also submit the form. With the list closed it means what it always means —
  // blocking it unconditionally made Enter dead in the Adressen section, where the user
  // types a street and presses Enter to save. attachHereAutocomplete keeps aria-expanded
  // in sync with the list, and handles the highlighted-item case itself.
  preventSubmit(e) {
    if (e.key === "Enter" && this.fieldTarget.getAttribute("aria-expanded") === "true") {
      e.preventDefault()
    }
  }

  // Only write parts the suggestion actually carries. Picking a locality ("München")
  // resolves to a city/PLZ but no street — assigning the empty string there would erase
  // what the user typed instead of completing it.
  setAddressFields(fields) {
    if (this.hasCityTarget && fields.city) this.cityTarget.value = fields.city
    if (this.hasCountryTarget && fields.country) this.countryTarget.value = fields.country
    if (this.hasPostalTarget && fields.postalCode) this.postalTarget.value = fields.postalCode
    if (fields.street) this.fieldTarget.value = fields.street
  }
}
